import { Box } from "@mui/material";
import { ReactNode, useRef, useContext } from "react";
import Draggable from "react-draggable";

import { LayoutContext } from "../../contexts/layout/context";

export const RightPanel = (props: { children: ReactNode }) => {
  const { children } = props;
  const { rightPanelWidth, setRightPanelWidth, isSidebarOpen } =
    useContext(LayoutContext);
  const panelRef = useRef<HTMLDivElement>(null);
  const dragHandleRef = useRef<HTMLDivElement>(null);

  // Handler for drag event
  const handleDrag = (e: any, data: any) => {
    if (!setRightPanelWidth) return;
    const newWidth = rightPanelWidth - data.deltaX;
    setRightPanelWidth(newWidth);
  };

  return (
    <Box
      ref={panelRef}
      sx={{
        width: isSidebarOpen ? rightPanelWidth : 0,
        height: "100%",
        borderLeft: isSidebarOpen ? "1px solid" : "none",
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        pointerEvents: isSidebarOpen ? "auto" : "none",
        opacity: isSidebarOpen ? 1 : 0,
        right: 0,
        top: 0,
        zIndex: 1200,
        background: "#fff",
        position: "relative",
        transition:
          "width 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s, max-width 0.3s, opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      {/* Draggable handle only when open */}
      {isSidebarOpen && (
        <Draggable
          axis="x"
          onDrag={handleDrag}
          position={{ x: 0, y: 0 }}
          nodeRef={dragHandleRef}
        >
          <div
            ref={dragHandleRef}
            className="drag-handle"
            style={{
              width: 6,
              position: "absolute",
              left: -3,
              top: 0,
              bottom: 0,
              zIndex: 1000,
              background: "#eee",
            }}
          />
        </Draggable>
      )}
      {children}
    </Box>
  );
};
